module.exports = __webpack_public_path__ + "assets/hamburger_disabled-168a14.svg";